let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("aPemh")]).then(() => parcelRequire('56Vzx'));